import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'removeText'
})
export class RemoveTextPipe implements PipeTransform {

  transform(value: string): unknown {
    let result = value;

    result = result.replace('PRECIO ', '')

    return result;
  }
}
